import { render } from "./FooterComponent.vue?vue&type=template&id=311674ef"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=311674ef&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebase 8x8\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__